<template>
    <v-dialog v-model="shows" max-width="500">
        <v-card class="v-card--dialog">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">ID 접근 차단 안내</h3>
                <v-btn fab color="transparent" @click="exit" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <v-divider />
            <div class="v-card--dialog__body text-center pt-10 pb-6">
                5회 이상의 로그인 실패 기록이 확인 되었습니다. <br />
                대한문고의 서비스 이용을 원하신다면 <br />
                본인인증을 완료해주시기 바랍니다. <br />
            </div>
            <div class="v-card--dialog__foot">
                <v-row no-gutters justify="center" align="center" class="row--small">
                    <v-col cols="auto">
                        <v-btn color="primary" @click="$refs['kcbCert']?.open?.()">본인인증</v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card>
        <kcb-cert ref="kcbCert" @input="certify"></kcb-cert>
        <common-loader v-bind="{ loading }" />
    </v-dialog>
</template>
<script>
import api from "@/api";

import KcbCert from "@/components/plugins/kcb/kcb-cert.vue";
import CommonLoader from "@/components/common/common-loader.vue";

export default {
    components: {
        KcbCert,
        CommonLoader,
    },
    props: {
        username: { type: String, default: null },
    },
    data: () => ({
        shows: false,
        loading: false,
    }),
    methods: {
        open() {
            this.shows = true;
        },
        exit() {
            this.shows = false;
        },
        async certify({ _cert }) {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { username } = this;
                await api.v1.members.loginFailedCount.delete({
                    params: { _cert, username },
                });
                alert("ID 접근 차단이 해제되었습니다. 다시 로그인 해주세요.");
                this.exit();
            } finally {
                this.loading = false;
            }
        },
    },
    watch: {
        shows() {
            if (!this.shows) this.$emit("exit");
        },
    },
};
</script>

<style scoped></style>
